/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";

import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ComparisionChart = ({ label, id, ...props }) => {
  let [statesList, setStatesList] = useState([
    { stateName: "Maharastra", stateCode: "mh", color: "orange" },
    { stateName: "Tamil Nadu", stateCode: "tn", color: "purple" },
    { stateName: "Delhi", stateCode: "dl", color: "#5F9EA0" },
  ]);

  return (
    <div className="timeline-comparision-chart">
      <header className="chart-header">
        <div className="state-selector">
          <StateSelect
            id={id}
            statesList={statesList}
            setStatesList={setStatesList}
          />
        </div>
      </header>
      <div>
        <h3>{label}</h3>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart
            data={Object.values(props)}
            margin={{ top: 10, right: 50, left: 1, bottom: 10 }}
          >
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <CartesianGrid strokeDasharray="3 3" />
            {statesList.map((state) => (
              <Line
                key={state.stateCode}
                type="monotone"
                dot={false}
                dataKey={state.stateCode}
                stroke={state.color}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export function StateSelect({ id, statesList, setStatesList }) {
  return (
    <Autocomplete
      onChange={(e, v) => {
        setStatesList([...v]);
      }}
      multiple
      limitTags={8}
      size="small"
      id={id}
      options={top100Films}
      disableCloseOnSelect
      defaultValue={[top100Films[0], top100Films[1], top100Films[2]]}
      getOptionLabel={(option) => option.stateName}
      renderOption={(option, { selected }) => {
        return (
          <React.Fragment>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.stateName}
          </React.Fragment>
        );
      }}
      style={{ width: "100%" }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Select State"
          placeholder="States"
        />
      )}
    />
  );
}

const top100Films = [
  { stateName: "Maharastra", stateCode: "mh", color: "orange" },
  { stateName: "Tamil Nadu", stateCode: "tn", color: "purple" },
  { stateName: "Delhi", stateCode: "dl", color: "#5F9EA0" },
  { stateName: "Gujarat", stateCode: "gj", color: "#512DA8" },
  { stateName: "Rajasthan", stateCode: "rj", color: "#00796B" },
  { stateName: "Madhya Pradesh", stateCode: "mp", color: "#388E3C" },
  { stateName: "Uttar Pradesh", stateCode: "up", color: "Aqua" },
  { stateName: "West Bengal", stateCode: "wb", color: "#8A2BE2" },
  { stateName: "Andhra Pradesh", stateCode: "ap", color: "#A52A2A" },
  { stateName: "Bihar", stateCode: "br", color: "#7FFF00" },
  { stateName: "Karnataka", stateCode: "ka", color: "#D2691E" },
  { stateName: "Punjab", stateCode: "pb", color: "#FF7F50" },
  { stateName: "Telangana", stateCode: "tg", color: "#6495ED" },
  { stateName: "Jammu and Kashmir", stateCode: "jk", color: "#DC143C" },
  { stateName: "Odisha", stateCode: "or", color: "#00FFFF" },
  { stateName: "Haryana", stateCode: "hr", color: "#00008B" },
  { stateName: "Kerala", stateCode: "kl", color: "#B8860B" },
  { stateName: "Assam", stateCode: "as", color: "#006400" },
  { stateName: "Uttarakhand", stateCode: "ut", color: "#1E90FF" },
  { stateName: "Jharkhand", stateCode: "jh", color: "#B22222" },
  { stateName: "Chhattisgarh", stateCode: "ct", color: "#228B22" },
  { stateName: "Chandigarh", stateCode: "ch", color: "#FF00FF" },
  { stateName: "Himachal Pradesh", stateCode: "hp", color: "#FFD700" },
  { stateName: "Tripura", stateCode: "tr", color: "#DAA520" },
  { stateName: "Goa", stateCode: "ga", color: "#ADFF2F" },
  { stateName: "Ladakh", stateCode: "la", color: "#CD5C5C" },
  { stateName: "Puducherry", stateCode: "py", color: "#4B0082" },
  { stateName: "Manipur", stateCode: "mn", color: "#90EE90" },
  {
    stateName: "Andaman and Nicobar Islands",
    stateCode: "an",
    color: "#C71585",
  },
  {
    stateName: "Meghalaya",
    stateCode: "ml",
    color: "#FF4500",
  },
  {
    stateName: "Nagaland",
    stateCode: "nl",
    color: "#DA70D6",
  },
  {
    stateName: "Dadra and Nagar Haveli and Daman and Diu",
    stateCode: "dn",
    color: "#CD853F",
  },
  {
    stateName: "Arunachal Pradesh",
    stateCode: "ar",
    color: "#4169E1",
  },
  {
    stateName: "Mizoram",
    stateCode: "mz",
    color: "#8B4513",
  },
  {
    stateName: "Sikkim",
    stateCode: "sk",
    color: "#FF6347",
  },
];
export default ComparisionChart;
